import React, { useEffect, useRef, useState } from "react";
import { categoryDetails, uploadFileAction } from "../actions/category";
import { useDispatch, useSelector } from "react-redux";
import { googleApiKey, RoutesPaths } from "../Router/constant";
import { useNavigate } from "react-router-dom";
import { storeAddAction } from "../actions/store";
import toast from "react-hot-toast";
import { GoogleMap, Marker, useJsApiLoader } from "@react-google-maps/api";
import { Quill } from "react-quill";
import { useForm } from "react-hook-form";
import { toogleErrorMessage } from "../actions/alertMessage";
import { allCategories } from "../actions/category";
import Select from "react-select";

export default function AddStore() {
  const { setValue } = useForm();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [imageFile, setImageFile] = useState(null);
  const [imagePreview, setImagePreview] = useState(null);
  const [errors, setErrors] = useState({});
  const [isimageId, setImageId] = useState();
  const [isMultiimageId, setMultiImageId] = useState([]);
  const [formData, setFormData] = useState({
    storeName: "",
    storeDescription: "",
    storeUserName: "",
    phoneNumber: "",
    emailAddress: "",
    webSite: "",
  });
  const [loading, setLoading] = useState(false);
  const [galleryPreviews, setGalleryPreviews] = useState([]);
  const [selectedCategoryId, setSelectedCategoryId] = useState("");
  const containerStyle = {
    width: "100%",
    height: "100%",
  };
  const libraries = ["places"];
  const { isLoaded } = useJsApiLoader({
    googleMapsApiKey: googleApiKey,
    libraries,
  });
  const [categoryList, setCategories] = useState([]);

  useEffect(() => {
    dispatch(categoryDetails("", 1, " "));
  }, []);

  useEffect(() => {
    getCurrentLocationOfUser();
  }, []);
  useEffect(() => {
    const fetchData = async () => {
      const res = await dispatch(allCategories());

      if (res?.status === 200) {
        setCategories(res.data);
      }


    };

    fetchData();
  }, [dispatch]);

  const handleCategoryChange = (e) => {
    const value = e.target.value;
    setSelectedCategoryId(value);

    if (value) {
      setErrors((prev) => ({
        ...prev,
        category: "",
      }));
    }
  };

  const handleGalleryChange = async (e) => {
    const files = Array.from(e.target.files);

    const previews = files.map((file) => ({
      file,
      preview: URL.createObjectURL(file),
    }));

    setGalleryPreviews((prev) => [...prev, ...previews]);

    for (const file of files) {
      const payload = new FormData();
      payload.append("files", file);

      try {
        const response = await dispatch(uploadFileAction(payload));
        if (response?.data?.data?._id) {
          setMultiImageId((prev) => [...prev, response.data.data._id]);
        }
      } catch (error) {
        setErrors((prev) => ({
          ...prev,
          icon: "Image upload failed",
        }));
      }
    }
  };

  const handleRemoveGalleryImage = (index) => {
    setGalleryPreviews((prev) => prev.filter((_, i) => i !== index));
    setMultiImageId((prev) => prev.filter((_, i) => i !== index));
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));

    // clear errors
    if (value.trim() !== "") {
      setErrors((prev) => ({ ...prev, [name]: "" }));
    }
  };
  const handleImageChange = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    if (!["image/png", "image/jpeg", "image/jpg"].includes(file.type)) {
      setErrors((prev) => ({
        ...prev,
        icon: "Only PNG, JPG, JPEG files are allowed",
      }));
      return;
    }
    setErrors((prev) => ({ ...prev, icon: "" }));
    setImageFile(file);
    setImagePreview(URL.createObjectURL(file));
    const payload = new FormData();
    payload.append("files", file);
    try {
      const response = await dispatch(uploadFileAction(payload));
      if (response?.data) {
        setImageId(response.data.data._id);
      }
    } catch (error) {
      setErrors((prev) => ({
        ...prev,
        icon: "Image upload failed",
      }));
    }
  };

  const handleRemoveImage = () => {
    setImageFile(null);
    setImagePreview(null);
  };

  const validate = () => {
    let newErrors = {};

    if (!formData.storeName.trim()) {
      newErrors.storeName = "Store name is required";
    }

    if (!formData.phoneNumber.trim()) {
      newErrors.phoneNumber = "Phone number is required";
    } else if (!/^\d{9}$/.test(formData.phoneNumber)) {
      newErrors.phoneNumber = "Please enter full 9-digit phone number";
    }

    if (!formData.emailAddress.trim()) {
      newErrors.emailAddress = "Email address is required";
    } else if (
      !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.emailAddress)
    ) {
      newErrors.emailAddress = "Enter a valid email address";
    }

    if (!selectedCategoryId || selectedCategoryId.trim() === "") {
      newErrors.category = "Category is required";
    }
    if (!imageFile) {
      newErrors.icon = "Store image is required";
    }
    if (formData.webSite.trim()) {
      const urlPattern = /^(https?:\/\/)?([\w.-]+)\.([a-z]{2,})(\/.*)?$/i;

      if (!urlPattern.test(formData.webSite)) {
        newErrors.webSite = "Enter a valid website URL";
      }
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validate()) return;
    setLoading(true);
    try {
      const payload = {
        sellerName: formData.storeUserName,
        shopName: formData.storeName,
        mainImage: isimageId,
        images: isMultiimageId,
        category: selectedCategoryId,
        contact: {
          phone: formData.phoneNumber,
          email: formData.emailAddress,
          website: formData.webSite,
        },
        description: formData.storeDescription,
        address: {
          full: address,
          city: " ",
          country: " ",
        },
        location: {
          type: "Point",
          coordinates: [
            String(currentLocation.lng),
            String(currentLocation.lat),
          ],
        },
      };

      const resp = await dispatch(storeAddAction(payload));
      if (resp.data.success) {
        navigate(RoutesPaths.STORS);
      }
    } catch (error) {
      toast.error("error:", error);
    } finally {
      setLoading(false);
    }
  };

  const canceChanges = () => {
    navigate(RoutesPaths.STORS);
  };

  const [address, setAddress] = useState("");
  const [currentLocation, setCurrentLocation] = useState({
    lat: null,
    lng: null,
  });

  const fallbackReverseGeocode = async (location) => {
    const address = await reverseGeocode(location);
    setAddress(address);
    setValue("fullAddress", address);
  };

  const getCurrentLocationOfUser = () => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        async (position) => {
          const { latitude, longitude } = position.coords;
          const location = { lat: latitude, lng: longitude };
          setCurrentLocation(location);

          try {
            // Check if Google Maps JS is loaded
            if (
              typeof window !== "undefined" &&
              window.google?.maps?.Geocoder
            ) {
              const geocoder = new window.google.maps.Geocoder();
              geocoder.geocode({ location }, (results, status) => {
                if (status === "OK" && results[0]) {
                  const formattedAddress = results[0].formatted_address;
                  setAddress(formattedAddress);
                  setValue("fullAddress", formattedAddress);
                } else {
                  console.warn("No results from geocoder, using fallback");
                  fallbackReverseGeocode(location);
                }
              });
            } else {
              console.warn("Google Maps not loaded yet, using fallback");
              fallbackReverseGeocode(location);
            }
          } catch (err) {
            console.error("Reverse geocoding failed", err);
            fallbackReverseGeocode(location);
          }
        },
        (error) => {
          switch (error.code) {
            case error.PERMISSION_DENIED:
              dispatch(
                toogleErrorMessage(
                  "Please allow location access in your browser settings.",
                ),
              );
              break;
            case error.POSITION_UNAVAILABLE:
              dispatch(
                toogleErrorMessage("Location information is unavailable."),
              );
              break;
            case error.TIMEOUT:
              dispatch(
                toogleErrorMessage(
                  "The request to get your location timed out.",
                ),
              );
              break;
            default:
              dispatch(
                toogleErrorMessage(
                  "An unknown error occurred while getting location.",
                ),
              );
              break;
          }
        },
      );
    } else {
      dispatch(
        toogleErrorMessage("Geolocation is not supported by this browser."),
      );
    }
  };
  const SearchBox = ({ onPlaceSelect, address }) => {
    const inputRef = useRef(null);
    const autocompleteRef = useRef(null);
    const [inputValue, setInputValue] = useState("");

    useEffect(() => {
      if (!isLoaded) return;
      if (!window.google) return;
      if (!inputRef.current) return;

      autocompleteRef.current = new window.google.maps.places.Autocomplete(
        inputRef.current,
        {
          types: ["geocode"],
        },
      );

      autocompleteRef.current.addListener("place_changed", () => {
        const place = autocompleteRef.current.getPlace();

        if (place?.geometry) {
          const location = {
            lat: place.geometry.location.lat(),
            lng: place.geometry.location.lng(),
          };

          const formatted = place.formatted_address || place.name || "";

          setInputValue(formatted);
          onPlaceSelect(location, place);
        }
      });
    }, [isLoaded]);

    useEffect(() => {
      setInputValue(address || "");
    }, [address]);

    return (
      <input
        type="text"
        className="search-inputCustom"
        placeholder="Enter store location"
        ref={inputRef}
        value={inputValue}
        onChange={(e) => {
          const value = e.target.value;
          setInputValue(value);

          if (value.trim() === "") {
            onPlaceSelect(null, null);
          }
        }}
      />
    );
  };

  const reverseGeocode = async ({ lat, lng }) => {
    const apiKey = googleApiKey;
    const response = await fetch(
      `https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lng}&key=${apiKey}`,
    );
    const data = await response.json();
    if (data?.results?.[0]) {
      return data.results[0].formatted_address;
    }
    return "Unknown Location";
  };

  const editorRef = useRef(null);
  const quillRef = useRef(null);

  useEffect(() => {
    if (!editorRef.current) return;

    quillRef.current = new Quill(editorRef.current, {
      theme: "snow",
      placeholder: "Store description",
      modules: {
        toolbar: [
          [{ header: [1, 2, false] }],
          ["bold", "italic", "underline"],
          ["image", "code-block"],
        ],
      },
    });

    quillRef.current.on("text-change", () => {
      const value = quillRef.current.root.innerHTML;

      setFormData((prev) => ({
        ...prev,
        storeDescription: value,
      }));
    });

  }, []);

  return (
    <>
      <div className="container-fluid mainConatinerSection">
        <form
          className="form d-flex flex-column flex-lg-row"
          onSubmit={handleSubmit}
        >
          <div className="d-flex flex-column gap-7 gap-lg-10 w-100 w-lg-300px mb-7 me-lg-10">
            <div className="card card-flush py-4">
              <div className="card-header">
                <div className="card-title">
                  <h2 className="required">Main Store Image</h2>
                </div>
              </div>
              <div className="card-body text-center pt-0">
                <div
                  className={`image-input image-input-outline mb-3 ${imagePreview
                    ? ""
                    : "image-input-empty image-input-placeholder"
                    }`}
                >
                  <div
                    className="image-input-wrapper w-150px h-150px"
                    style={{
                      backgroundImage: imagePreview
                        ? `url(${imagePreview})`
                        : "none",
                    }}
                  ></div>

                  <label className="btn btn-icon btn-circle btn-active-color-primary w-25px h-25px bg-body shadow pencilIconSection">
                    <i className="ki-duotone ki-pencil fs-7">
                      <span className="path1 searchPath"></span>
                      <span className="path2 searchPath"></span>
                    </i>
                    <input
                      type="file"
                      accept=".png,.jpg,.jpeg"
                      hidden
                      onChange={handleImageChange}
                    />
                  </label>

                  {imagePreview && (
                    <span
                      className="btn btn-icon btn-circle btn-active-color-primary w-25px h-25px bg-body shadow closeIconSection"
                      onClick={handleRemoveImage}
                    >
                      <i className="ki-duotone ki-cross fs-2">
                        <span className="path1"></span>
                        <span className="path2"></span>
                      </i>
                    </span>
                  )}
                </div>

                {errors.icon && (
                  <div className="text-danger fs-7">{errors.icon}</div>
                )}

                <div className="text-muted fs-7">
                  Only *.png, *.jpg and *.jpeg image files are accepted
                </div>
              </div>
            </div>

            <div className="card card-flush py-4">
              <div className="card-header">
                <div className="card-title">
                  <h2>Store Gallery Images</h2>
                </div>
              </div>

              <div className="card-body pt-0">
                <div className="d-flex flex-wrap gap-4 justify-content-center">
                  {/* Existing Images */}
                  {galleryPreviews.map((img, index) => (
                    <div
                      key={index}
                      className="image-input image-input-outline mb-3"
                    >
                      <div
                        className="image-input-wrapper w-100px h-100px"
                        style={{ backgroundImage: `url(${img.preview})` }}
                      ></div>

                      {/* Remove */}
                      <span
                        className="btn btn-icon btn-circle btn-active-color-primary w-25px h-25px bg-body shadow pencilIconSection"
                        onClick={() => handleRemoveGalleryImage(index)}
                      >
                        <i className="ki-duotone ki-cross fs-2">
                          <span className="path1"></span>
                          <span className="path2"></span>
                        </i>
                      </span>
                    </div>
                  ))}

                  {/* Add New Image */}
                  <div className="image-input image-input-empty image-input-outline image-input-placeholder mb-3">
                    <div className="image-input-wrapper w-100px h-100px"></div>

                    <label className="btn btn-icon btn-circle btn-active-color-primary w-25px h-25px bg-body shadow pencilIconSection">
                      <i className="ki-duotone ki-pencil fs-7">
                        <span className="path1 searchPath"></span>
                        <span className="path2 searchPath"></span>
                      </i>

                      <input
                        type="file"
                        accept=".png,.jpg,.jpeg"
                        multiple
                        hidden
                        onChange={handleGalleryChange}
                      />
                    </label>
                  </div>
                </div>

                <div className="text-muted fs-7 text-center mt-3">
                  Upload store gallery images. Only *.png, *.jpg and *.jpeg
                  image files are accepted.
                </div>
              </div>
            </div>
          </div>
          <div className="d-flex flex-column flex-row-fluid gap-7 gap-lg-10">
            <div className="card card-flush py-4">
              <div className="card-header">
                <div className="card-title">
                  <h2>General</h2>
                </div>
              </div>
              <div className="card-body pt-0">
                <div className="mb-10 fv-row">
                  <label className="required form-label">Store name</label>
                  <input
                    type="text"
                    name="storeName"
                    className="form-control mb-2"
                    placeholder="Store name"
                    value={formData.storeName}
                    onChange={handleChange}
                  />
                  {errors.storeName && (
                    <div className="text-danger fs-7">{errors.storeName}</div>
                  )}
                  <div className="text-muted fs-7">
                    A store name is required and recommended to be unique.
                  </div>
                </div>

                <div className="mb-10 fv-row">
                  <label className="form-label">Store user name</label>
                  <input
                    type="text"
                    name="storeUserName"
                    className="form-control mb-2"
                    placeholder="Store user name"
                    value={formData.storeUserName}
                    onChange={handleChange}
                  />
                  {errors.storeName && (
                    <div className="text-danger fs-7">
                      {errors.storeUserName}
                    </div>
                  )}
                </div>

                <div className="mb-10 fv-row">
                  <label className="form-label">Description</label>

                  <div
                    ref={editorRef}
                    className={`form-control form-controlDesc min-h-200px ${errors.storeDescription ? "border-danger" : ""
                      }`}
                  ></div>

                  {errors.storeDescription && (
                    <div className="text-danger fs-7 mt-1">
                      {errors.storeDescription}
                    </div>
                  )}

                  <div className="text-muted fs-7">
                    Set a description for your store.
                  </div>
                </div>

                <div className="mb-10 fv-row">
                  <label className="required form-label">Select category</label>

                  <Select
                    placeholder="Select a category"
                    value={categoryList?.data
                      ?.map(item => ({ value: item._id, label: item.name }))
                      .find(opt => opt.value === selectedCategoryId)
                    }
                    options={categoryList?.data?.map(item => ({
                      value: item._id,
                      label: item.name
                    }))}
                    onChange={(selected) => handleCategoryChange({ target: { value: selected.value } })}
                  />
                  {errors.category && (
                    <div className="text-danger fs-7">{errors.category}</div>
                  )}
                  <div className="text-muted fs-7">Set the category.</div>
                </div>
                <div className="mb-10 fv-row">
                  <label className="required form-label">Phone number</label>

                  <div className="input-group">
                    <span className="input-group-text">+244</span>

                    <input
                      type="tel"
                      name="phoneNumber"
                      className="form-control"
                      placeholder="Phone number"
                      value={formData.phoneNumber}
                      onChange={(e) => {
                        const value = e.target.value;

                        if (/^\d{0,9}$/.test(value)) {
                          handleChange(e);
                        }
                      }}
                    />
                  </div>

                  {errors.phoneNumber && (
                    <div className="text-danger fs-7">{errors.phoneNumber}</div>
                  )}
                </div>
                <div className="mb-10 fv-row">
                  <label className="required form-label">Email address</label>
                  <input
                    type="text"
                    name="emailAddress"
                    className="form-control mb-2"
                    placeholder="Email address"
                    value={formData.emailAddress}
                    onChange={handleChange}
                  />
                  {errors.emailAddress && (
                    <div className="text-danger fs-7">
                      {errors.emailAddress}
                    </div>
                  )}
                </div>
                <div className="mb-10 fv-row">
                  <label className="form-label">Website</label>
                  <input
                    type="text"
                    name="webSite"
                    className="form-control mb-2"
                    placeholder="Website address"
                    value={formData.webSite}
                    onChange={handleChange}
                  />
                  {errors.webSite && (
                    <div className="text-danger fs-7">{errors.webSite}</div>
                  )}
                </div>

                <div className="mb-10 fv-row">
                  <label className="form-label">Address</label>
                  <div>
                    <div className="form-control mb-2">
                      <img src="/assets/media/images/searchInput.svg" alt="" />
                      {isLoaded && (
                        <SearchBox
                          key={address} // 👈 Add this line
                          address={address}
                          onPlaceSelect={(location, place) => {
                            setCurrentLocation(location); // location = null when cleared
                            setAddress(place?.formatted_address || "");
                            setValue(
                              "fullAddress",
                              place?.formatted_address || "",
                            );
                          }}
                        />
                      )}
                    </div>

                    <div className="mapclass">
                      {isLoaded && currentLocation ? (
                        <GoogleMap
                          mapContainerStyle={containerStyle}
                          center={currentLocation}
                          zoom={15}
                          onClick={async (e) => {
                            const lat = e?.latLng.lat();
                            const lng = e?.latLng.lng();
                            const location = { lat, lng };
                            setCurrentLocation(location);

                            try {
                              const addr = await reverseGeocode({ lat, lng });
                              setAddress(addr);
                              setValue("fullAddress", addr);
                            } catch (err) {
                              console.warn("Failed to get address:", err);
                            }
                          }}
                          onDragEnd={async (e) => {
                            const lat = e?.latLng.lat();
                            const lng = e?.latLng.lng();
                            const location = { lat, lng };
                            setCurrentLocation(location);

                            try {
                              const addr = await reverseGeocode({ lat, lng });
                              setAddress(addr);
                              setValue("fullAddress", addr);
                            } catch (err) {
                              console.warn("Failed to get address:", err);
                            }
                          }}
                        >
                          <Marker
                            position={currentLocation}
                            draggable={true}
                            onDragEnd={async (e) => {
                              const lat = e?.latLng.lat();
                              const lng = e?.latLng.lng();
                              const location = { lat, lng };
                              setCurrentLocation(location);
                              try {
                                const addr = await reverseGeocode({ lat, lng });
                                setAddress(addr);
                                setValue("fullAddress", addr);
                              } catch (err) {
                                console.warn("Failed to get address:", err);
                              }
                            }}
                          />
                        </GoogleMap>
                      ) : (
                        <p>Fetching location...</p>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="d-flex justify-content-end">
              <button className="btn btn-light me-5" onClick={canceChanges}>
                Cancel
              </button>
              <button
                type="submit"
                disabled={loading}
                className="btn buttonPrimary"
              >
                <span className="indicator-label"></span>
                {!loading && (
                  <span className="indicator-label">Save Changes</span>
                )}
                {loading && (
                  <span className="indicator-label">
                    <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                    Please wait...
                  </span>
                )}
              </button>
            </div>
          </div>
        </form>
      </div>
    </>
  );
}
